export function initVariableBg($) {

	$('.variable-bg-block').each(function(n, el) {
		let block = $(el);
		let bg = block.data('bg');
		let random = block.data('random');
		let delay = parseInt(block.data('delay'));
		let interval;
		let isDebouncing = false;
		const debounceTime = 1500; // 1 second'

		// current bg index
		$(block).data('index', 0);


		if( isNaN(delay) || !delay ) {
			delay = 8000;
		}

		// shuffle the bg array if random start
		if( random ) {
			bg = bg.sort(() => Math.random() - 0.5);
		}

		// preload images and check when all loaded
		let loaded = 0;

		for( let i = 0; i < bg.length; i++ ) {
			let img = new Image();
			img.src = bg[i];

			// check load
			img.onload = () => {
				loaded++;
				if( loaded == bg.length ) {
					interval = startTransition(block, bg, delay);
				}
			}
		}

		// controls
		$('.controls > .prev', block).click(() => {
			if (isDebouncing) return;
    		isDebouncing = true;

			let index = block.data('index');
			let newIndex = index == 0 ? bg.length - 1 : index - 1;
			let newBg = bg[newIndex];
			block.data('index', newIndex);
			clearInterval(interval);
			block.css('background-image', `url(${newBg})`);
			interval = startTransition(block, bg, delay);

			setTimeout(() => {
				isDebouncing = false;
			}, debounceTime);
		});

		$('.controls > .next', block).click(() => {
			if (isDebouncing) return;
    		isDebouncing = true;

			let index = block.data('index');
			let newIndex = (index + 1) % bg.length;
			let newBg = bg[newIndex];
			block.data('index', newIndex);
			clearInterval(interval);
			block.css('background-image', `url(${newBg})`);
			interval = startTransition(block, bg, delay);

			setTimeout(() => {
				isDebouncing = false;
			}, debounceTime);
		});

	});
}

// change background every few seconds
function startTransition(block, backgrounds, delay) {
	return setInterval(() => {
		let index = block.data('index');
		let newBg = backgrounds[++index % backgrounds.length];
		block.css('background-image', `url(${newBg})`);
		block.data('index', index);
	}, delay);
}